import { HeaderCell, Row } from './InterestTableDTO';

export interface InterestTableState {
    error: boolean;
    data: Row[];
    headers: HeaderCell[];
    loading: boolean;
}

export const INITIAL_TABLE_STATE: InterestTableState = { error: false, data: [], headers: [], loading: true };
